export default {
    reverseGeocode: 'reverseGeocode',
    crossStreetLookup: 'reverseGeocode/crossStreet'
};
